module.exports = __webpack_public_path__ + "img/banner-1.90d9d62d.png";